import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Menu = () => {
  const { t, i18n } = useTranslation();
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const lang = i18n.language;
    
    setLoading(true); // Set loading to true before request
    axios.get(`${process.env.REACT_APP_API_URL}/api/menus?lang=${lang}`)
      .then((response) => {
        setMenuItems(response.data);
      })
      .catch((error) => {
        console.error('Error fetching menu:', error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false after request
      });
  }, [i18n.language]);

  return (
    <div className="menu-page">
      {loading ? (
        <p className="loading-message">{t('loading')}</p>
      ) : (
        <div className="cards-container">
          {menuItems.map((item, index) => (
            <div className="card" key={index}>
              <h3>{item.name}</h3>
              <p>{item.description}</p>
              <p>{t('price')} - ₪{item.price}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Menu;
